<template>
    <div class="check-box-wrapper">
      <label for="checkbox" :title="checkboxItem.name"> <span class="name"> {{checkboxItem.name}} </span>  -<span class="price"> ${{ checkboxItem.price }} </span> </label>
      <input
          type="checkbox"
          id="checkbox"
          :value="checkboxItem.value"
          @change="handleChange"
          :checked="checked"
          class="ms-2"
      >
    </div>
  </template>
  
  <script>
  export default  {
    name : 'PlanCheckBox',
    props: {
      checkboxItem : {
        required: true,
        type: Object,
      },
      checked: {
        type: Boolean,
      }
    },
  
    methods: {
      handleChange(e){
        this.$emit('onChange', {item: this.checkboxItem, checked: e.target.checked});
      },
    }
  }
  
  </script>
  
  <style>
  .check-box-wrapper{
    display: inline-flex;
    gap: .95rem;
    border: .1rem solid #1e1b1b;
    padding: .25rem .45rem;
    border-radius: .5rem;
    justify-content:space-between;
    margin: 5px;
  }
  
  .check-box-wrapper label {
    display: flex;
    flex-wrap: nowrap;
    white-space: nowrap;
    justify-content: space-between;
    width: 90%;
    gap: .85rem;
    font-size: .95rem;
    font-weight: 600;
  }
  
  .name {
    white-space: nowrap;
  }
  </style>